import { Component } from 'react';
import PublicView from '../components/view/PublicView';
import { trackInteraction } from '../tracking/tracker';
import { DOCUMENT_VIEW } from '../tracking/actions';

// @ts-expect-error No types
import hubspotGTMContainer from '../utils/hubspotGTMContainer';
// @ts-expect-error No types
import isMobile from 'isMobile';
import ViewNotAvailable from '../components/view/ViewNotAvailable';
import ViewNotFound from '../components/view/ViewNotFound';
import ViewError from '../components/view/ViewError';
import NoPermissionError from '../components/view/NoPermissionError';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ViewContainer extends Component {
  componentDidMount() {
    hubspotGTMContainer();
    if (this.props.presentation) {
      trackInteraction(DOCUMENT_VIEW);
      this.props.fetchMeetingLink();
    }
    if (!isMobile.any) {
      // Load the chat widget as long as we aren't on mobile. Automatic loading
      // is disabled in a script tag in view.html.jade
      window.hsConversationsOnReady = [() => {
        window.HubSpotConversations.widget.load();
      }];
    }
  }
  render() {
    const {
      presentation,
      sharedLink,
      presentationNotFound,
      presentationNotAvailableEndDate,
      meetingLink,
      identifyViewer,
      identifySharedLinkViewer,
      finishActivity,
      fetchDownloadLink,
      noPermission,
      requiresViewerInfo,
      legalConsent,
      legalConsentCHIRP,
      pageNumber,
      finishSessionCHIRP
    } = this.props;
    if (presentationNotAvailableEndDate) {
      return /*#__PURE__*/_jsx(ViewNotAvailable, {
        endDate: presentationNotAvailableEndDate
      });
    }
    if (presentation === undefined) {
      if (presentationNotFound) {
        return /*#__PURE__*/_jsx(ViewNotFound, {});
      }
      if (noPermission) {
        return /*#__PURE__*/_jsx(NoPermissionError, {});
      }
      return /*#__PURE__*/_jsx(ViewError, {});
    }
    return /*#__PURE__*/_jsx(PublicView, {
      presentation: presentation,
      sharedLink: sharedLink,
      meetingLink: meetingLink,
      onIdentifyViewer: identifyViewer,
      onIdentifySharedLinkViewer: identifySharedLinkViewer,
      onFinishActivity: finishActivity,
      fetchDownloadLink: fetchDownloadLink,
      requiresViewerInfo: requiresViewerInfo,
      legalConsent: legalConsent,
      legalConsentCHIRP: legalConsentCHIRP,
      pageNumber: pageNumber,
      onFinishSessionCHIRP: finishSessionCHIRP
    });
  }
}